// 定時処理の予定表（HOME の「ランキング」横の ？ から開くモーダルで表示する）
// アム・ポチ・FSスクレイパーの定時処理を変えたら、この一覧と最終更新日も直すこと。
// ポチは pochi-serverside の app/Console/Kernel.php
// ※ FSスクレイパーの分はシステム「アム」として載せている

export const SCHEDULE_LAST_UPDATED = '2026-10-15'

export const SYSTEM = {
    AM: 'アム',
    POCHI: 'ポチ',
}

// 毎日（時刻順。「毎時」は開始時刻の位置に置く。同じ時刻は アム → ポチ の順）
export const DAILY_SCHEDULES = [
    { time: '0:00', system: SYSTEM.AM, content: '受注の取り込み（全モール、3か月分）' },
    { time: '0:00', system: SYSTEM.AM, content: '古い取り込み状況の記録を片付ける' },
    { time: '0:00', system: SYSTEM.POCHI, content: '自社広告費の按分率を保存（前日と同じ割合）' },
    { time: '1:00', system: SYSTEM.POCHI, content: 'アムの売上を取り込む（1年分）' },
    { time: '1:15', system: SYSTEM.POCHI, content: '売上・費用を日ごとに集計（1年分。前日までの確定値）' },
    { time: '4:00', system: SYSTEM.AM, content: 'Yahoo!広告へ前日の受注（コンバージョン）を送信' },
    { time: '4:00', system: SYSTEM.POCHI, content: '広告費を取得（Google・Yahoo!・LINE・Microsoft・Facebook）' },
    { time: '5:00', system: SYSTEM.POCHI, content: '広告費の取得に失敗した分を取り直す' },
    { time: '6:00〜9:00 毎時', system: SYSTEM.POCHI, content: 'アムの売上を取り込む（180日分・前日まで）' },
    { time: '6:05〜8:05 毎時', system: SYSTEM.POCHI, content: '日ごとの集計（30日分・前日まで）' },
    { time: '6:30', system: SYSTEM.POCHI, content: 'モール施策期間の売上・個数を集計' },
    { time: '8:00', system: SYSTEM.AM, content: 'FutureShop の入金確認のあと、受注を取り込む（直近約3日分）' },
    { time: '8:00', system: SYSTEM.POCHI, content: '広告費を取得（Google・Yahoo!・LINE・Microsoft・Facebook）' },
    { time: '8:30〜11:30 毎時', system: SYSTEM.POCHI, content: 'Googleアナリティクスのデータを取得（前日分）' },
    { time: '8:45〜11:45 毎時', system: SYSTEM.POCHI, content: 'BigQuery へデータを送る（前日分）' },
    { time: '10:00', system: SYSTEM.POCHI, content: '広告費を取得（Google・Yahoo!・LINE・Microsoft）' },
    { time: '11:00', system: SYSTEM.POCHI, content: '広告費を取得（Facebook）' },
    { time: '12:00', system: SYSTEM.AM, content: '半年前〜4か月前の受注を取り込み直す（今月最後の日曜日か祝日だけ）' },
    { time: '12:00', system: SYSTEM.POCHI, content: '広告費を取得（Google・Yahoo!・LINE・Microsoft）' },
    { time: '12:00', system: SYSTEM.POCHI, content: 'Googleアナリティクスのデータを取得（7日分）' },
    { time: '12:00〜16:00 毎時', system: SYSTEM.POCHI, content: 'アムの売上を取り込む（180日分・前日まで）' },
    { time: '12:05〜15:05 毎時', system: SYSTEM.POCHI, content: '日ごとの集計（30日分・前日まで）' },
    { time: '12:15', system: SYSTEM.POCHI, content: 'BigQuery へデータを送る（7日分）' },
    { time: '13:30〜17:30 毎時', system: SYSTEM.POCHI, content: 'Googleアナリティクスのデータを取得（前日分）' },
    { time: '13:45〜17:45 毎時', system: SYSTEM.POCHI, content: 'BigQuery へデータを送る（前日分）' },
    { time: '16:00', system: SYSTEM.AM, content: 'FutureShop の入金確認のあと、受注を取り込む（直近約3日分）' },
    { time: '19:00〜22:00 毎時', system: SYSTEM.POCHI, content: 'アムの売上を取り込む（180日分・当日まで）' },
    { time: '19:05〜23:05 毎時', system: SYSTEM.POCHI, content: '日ごとの集計（30日分・当日まで。HOME に今日の売上が出る）' },
    { time: '21:30', system: SYSTEM.POCHI, content: 'スマレジの店舗売上を取り込む（直近7日分＋当日）' },
    { time: '22:00', system: SYSTEM.POCHI, content: '最新の原価を取得' },
    { time: '22:30', system: SYSTEM.AM, content: '受注の取り込み（当日分だけ）' },
    { time: '23:00', system: SYSTEM.POCHI, content: 'アムの売上を取り込む（前日と当日の2日分。22:30 の取り込み分を拾う）' },
    { time: '23:50', system: SYSTEM.AM, content: 'FutureShop の入金確認（取り込みは 0:00 に任せる）' },
]

// 曜日・随時・毎月・毎年
export const OTHER_SCHEDULES = [
    { time: '土曜 13:00・15:00・17:00・19:00', system: SYSTEM.POCHI, content: 'Facebook 広告費の過去分を取り直す（10〜13日前）' },
    { time: '日曜 13:00・15:00・17:00', system: SYSTEM.POCHI, content: 'Facebook 広告費の過去分を取り直す（8〜10日前）' },
    { time: '5分ごと', system: SYSTEM.AM, content: '予約の反映（API・GOLD・CSV）と slot_control.css の更新' },
    { time: '毎月1日 0:00', system: SYSTEM.AM, content: '取り込んだ CSV を ZIP にまとめる' },
    { time: '毎月1日 5:45', system: SYSTEM.POCHI, content: '月ごとの集計' },
    { time: '1月1日', system: SYSTEM.AM, content: '祝日を自動で登録' },
]
